import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { Spinner } from "react-bootstrap";
import "./verificationCodeInput.css";
import { clearConfirmPasswordResetError } from "../../../containers/CreateAccount/slice";
import { clearErrors } from "../../../containers/VerifyEmail/slice";

const VerificationCodeInput = ({
  onComplete,
  onSubmit,
  error,
  isLoading,
  actionButtonText = "",
  showResend = true,
  onResend,
  isResending,
  timeLeft,
  autoSubmit = false,
}) => {
  const dispatch = useDispatch();
  const [verificationCode, setVerificationCode] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const inputRefs = useRef([]);

  const handleInputChange = (index, value) => {
    dispatch(clearConfirmPasswordResetError());
    dispatch(clearErrors());

    if (value.length <= 1) {
      const newCode = [...verificationCode];
      newCode[index] = value;
      setVerificationCode(newCode);

      // Auto-focus next input
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }

      // Always notify parent of code completion
      if (index === 5 && value) {
        const completeCode = [...newCode.slice(0, 5), value].join("");
        onComplete(completeCode);
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !verificationCode[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pastedData)) {
      const digits = pastedData.split("");
      setVerificationCode(digits);
      inputRefs.current[5].focus();
      onComplete(pastedData);
    }
  };

  return (
    <div className="verification-code-container">
      <div className={`verification-code-inputs ${error ? "error" : ""}`}>
        {verificationCode.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => handleInputChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={index === 0 ? handlePaste : null}
            className="code-input"
          />
        ))}
      </div>

      {error && <div className="error-message">{error}</div>}

      {actionButtonText && (
        <button
          className="primary-action-button"
          onClick={onSubmit}
          disabled={verificationCode.some((digit) => digit === "") || isLoading}
        >
          {isLoading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="loading-button-spinner"
            />
          ) : (
            actionButtonText
          )}
        </button>
      )}

      {showResend && (
        <div className={`${actionButtonText ? "resend-container" : ""}`}>
          {isResending ? (
            <p className="resend-message">
              Resend in 00:{timeLeft < 10 ? `0${timeLeft}` : timeLeft}
            </p>
          ) : (
            <button
              className="text-button-link resend-button"
              onClick={onResend}
            >
              Resend Code
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default VerificationCodeInput;
